import styled from 'styled-components';

const StyledFieldInfo = styled.div`
  padding: ${(props): string => props.theme.spaces.md};
  max-width: 30rem;
`;

export default StyledFieldInfo;
